const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath,
  getValue = _require.getValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate readContentValueBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceContentPath = await evaluateSource(source.sourceContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (sourceContentPath === undefined) {
    return undefined;
  }
  const path = appendPath(parentContentPath, sourceContentPath);
  if (path === '/') {
    return content;
  }
  return getValue(path, content);
};
module.exports = {
  evaluate
};